export const EXCEPT_SYMBOLS = ["e", "E", "+", "-", "."];
